"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinishAuthoriserFlowEvent = exports.ResentChallengeEvent = exports.AuthoriserStateChangedEvent = exports.InitAuthoriserEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class InitAuthoriserEvent extends web_ui_framework_1.Event {
}
exports.InitAuthoriserEvent = InitAuthoriserEvent;
class AuthoriserStateChangedEvent extends web_ui_framework_1.Event {
}
exports.AuthoriserStateChangedEvent = AuthoriserStateChangedEvent;
class ResentChallengeEvent extends web_ui_framework_1.Event {
}
exports.ResentChallengeEvent = ResentChallengeEvent;
class FinishAuthoriserFlowEvent extends web_ui_framework_1.Event {
}
exports.FinishAuthoriserFlowEvent = FinishAuthoriserFlowEvent;
//# sourceMappingURL=authoriserEvents.js.map